import { useQuery } from '@tanstack/react-query';
import {
  api,
  type AdminUser,
  type AuditEntry,
  type ReleaseFeed,
  type User,
} from './api';

export function useMe() {
  return useQuery<User | null>({
    queryKey: ['me'],
    queryFn: async () => (await api<{ user: User | null }>('/api/auth/session')).user,
    retry: false,
    staleTime: 60_000,
  });
}

export function useUsers(enabled = true) {
  return useQuery<AdminUser[]>({
    queryKey: ['users'],
    queryFn: async () => (await api<{ users: AdminUser[] }>('/api/admin/users')).users,
    enabled,
    staleTime: 10_000,
  });
}

export function useAudit(enabled = true) {
  return useQuery<AuditEntry[]>({
    queryKey: ['audit'],
    queryFn: async () => (await api<{ entries: AuditEntry[] }>('/api/admin/audit')).entries,
    enabled,
    staleTime: 10_000,
  });
}

export function useReleases(enabled = true) {
  return useQuery<ReleaseFeed>({
    queryKey: ['releases'],
    queryFn: () => api<ReleaseFeed>('/api/releases?limit=60'),
    enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}